export default "__VITE_ASSET__DFQXy4Q7__"